export default __webpack_public_path__ + "static/niche@768-f18287cf1710c2c9213f7ca18308fea0.png";